import BaseModel from '../../../../base';
import TournamentStageGroupDopScoreItem from './item';
import {
  TOURNAMENT_DOP_SCORE_MIN_SECTION_ITEMS,
  TOURNAMENT_DOP_SCORE_TOTAL_ITEM_NAME,
  TOURNAMENT_DOP_SCORE_TYPES,
} from './constants';

export default class TournamentStageGroupDopScore extends BaseModel {
  constructor(dopScore = {}, url = 'tournament-stage-group-dop-scores') {
    super(dopScore, url);

    this.tournament_stage_group_id = dopScore.tournament_stage_group_id ?? null;
    this.type = Number(dopScore.type || TOURNAMENT_DOP_SCORE_TYPES.total);
    this.type_description = dopScore.type_description || '';
    this.convert_to_100_scale = !!dopScore.convert_to_100_scale;
    this.decimal_places = Number(dopScore.decimal_places ?? 2);
    this.tournament_dop_score_template_id = dopScore.tournament_dop_score_template_id ?? null;
    this.is_inherited = !!(dopScore.is_inherited || this.tournament_dop_score_template_id);
    this.items = (dopScore.items || [])
      .map((item) => new TournamentStageGroupDopScoreItem(item))
      .sort((first, second) => first.order - second.order);
    this.created_at = dopScore.created_at;
  }

  get isTotal() {
    return this.type === TOURNAMENT_DOP_SCORE_TYPES.total;
  }

  get scoreItems() {
    return this.isTotal ? this.items.slice(0, 1) : this.items;
  }

  toForm() {
    return {
      type: this.type,
      convert_to_100_scale: this.convert_to_100_scale,
      decimal_places: this.decimal_places,
      items: this.items.map((item) => item.toForm()),
    };
  }

  parentPayload(groupId = this.tournament_stage_group_id) {
    return this.isServer
      ? { type: this.type }
      : { tournament_stage_group_id: groupId, type: this.type };
  }

  hasRemovedItems(form) {
    const currentIds = (form.items || []).map(({ id }) => id).filter(Boolean);
    return this.items.some(({ id, isServer }) => isServer && !currentIds.includes(id));
  }

  hasSameItems(items) {
    return this.items.length === items.length && items.every(({ id, name, max_score }, index) => (
      String(id) === String(this.items[index].id)
      && String(name).trim() === this.items[index].name
      && Number(max_score ?? -1) === Number(this.items[index].max_score ?? -1)
    ));
  }

  static createItem(item = {}, index = 0) {
    return new TournamentStageGroupDopScoreItem({
      name: item.name || `Раздел ${index + 1}`,
      order: item.order ?? index,
      max_score: 100,
      ...item,
    }).toForm();
  }

  static defaultItems(type) {
    if (type === TOURNAMENT_DOP_SCORE_TYPES.total) {
      return [this.createItem({ name: TOURNAMENT_DOP_SCORE_TOTAL_ITEM_NAME }, 0)];
    }
    return Array.from(
      { length: TOURNAMENT_DOP_SCORE_MIN_SECTION_ITEMS },
      (_, index) => this.createItem({}, index),
    );
  }

  static get constants() {
    return {
      TOURNAMENT_DOP_SCORE_MIN_SECTION_ITEMS,
      TOURNAMENT_DOP_SCORE_TOTAL_ITEM_NAME,
      TOURNAMENT_DOP_SCORE_TYPES,
    };
  }
}
